import React from 'react';
import { func, bool } from 'prop-types';
import { SurveySchemaPartItemEditorType } from '../../../../constants/types';
import { withLang, langType } from '../../../../i18n';
import { LocalizedInput } from '../../../LocalizedInput';
import styles from './heading.module.css';

const Heading = ({
  item,
  onRemove,
  onLocalizedHeadingInputChange,
  lockedFromEditing, translate: t
}) => (
  <div>
    <div className={styles.itemHeader}>
      <button
        type="button"
        className="actionButton icon--trash iconRemove"
        onClick={onRemove}
        title={t('common.remove')}
        disabled={lockedFromEditing}
      />

    </div>
    <LocalizedInput
      name="text"
      values={item.staticText.text}
      onInputChange={onLocalizedHeadingInputChange}
      placeholderTranslationNamespace="inLanguage"
      maxLength={255}
    />
  </div>
);

Heading.propTypes = {
  item: SurveySchemaPartItemEditorType.isRequired,
  onRemove: func.isRequired,
  onLocalizedHeadingInputChange: func.isRequired,
  lockedFromEditing: bool.isRequired,
  ...langType
};

export default withLang(Heading);
